<template>
    <div style="text-align: center; margin:auto; max-width:900px">
    <img
    src="public/images/site/compartir.svg"
    id="challenges"
    alt="Miles de proyectos"
    style="margin-top: 50px; width:80%"
  />



    <div
    style="
    background-color: #ececec;
    margin-left: 20px;
    margin-right: 20px; border-radius:15px"
    >
       <img
    src="public/images/site/share.svg"
    id="challenges"
    alt="Miles de proyectos"
    style="border-radius:15px; margin:20px"
  />
    
    </div>




    <img
    src="public/images/site/paint-grey.svg"
    id="challenges"
    alt="Miles de proyectos"
    style=" margin-top:-5px; "
  />



  </div>
</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    
    name: 'share-banner',

    data () {
      return {
        errorMessage:"",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{

    },

    mounted: function(){

    },


  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/startPage/ShareBanner.vue